/**
 * Format phone number from masked format to international format
 * Converts from "(30) 123 4567" to "+36301234567"
 *
 * @param {string} phone - Phone number in masked format
 * @returns {string} Phone number in international format (+36XXXXXXXXX)
 */
export function formatPhoneToInternational(phone) {
    if (!phone) {
        return "";
    }

    // Remove all non-digit characters
    const digitsOnly = phone.replace(/\D/g, "");

    // If it's already in international format (starts with 36), add the +
    if (digitsOnly.startsWith("36") && digitsOnly.length === 11) {
        return "+" + digitsOnly;
    }

    // If it's a local Hungarian number (9 digits), add +36 prefix
    if (digitsOnly.length === 9) {
        return "+36" + digitsOnly;
    }

    // If it's 10 digits and starts with 0, remove the 0 and add +36
    if (digitsOnly.length === 10 && digitsOnly.startsWith("0")) {
        return "+36" + digitsOnly.substring(1);
    }

    // Return the original if we can't determine the format
    return phone;
}

/**
 * Check if a phone number is in the correct international format
 *
 * @param {string} phone - Phone number to check
 * @returns {boolean} True if in correct format (+36XXXXXXXXX)
 */
export function isValidInternationalFormat(phone) {
    if (!phone) {
        return false;
    }

    // Should start with +36 and be 12 characters total
    const phoneRegex = /^\+36\d{9}$/;
    return phoneRegex.test(phone);
}
